import React from 'react';

const Error = () => {
  return(
    <p>Something has gone wrong with navigation</p>
  );
};

export default Error;
